import { Phone } from 'types';

export const buildPhone = (phone: Phone): string => `${phone.countryCode}${phone.value}`;
